import { createSelector } from 'reselect';

const selectAccounts = (state: any) => state.accounts;


export const selectAccountsCurrentItem = createSelector([selectAccounts], (accounts) => accounts.current);

export const selectAccountsListItems = createSelector([selectAccounts], (accounts) => accounts.list);

export const selectAccountsItemById = (itemId: any) =>
    createSelector(selectAccountsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectAccountsQueryItems = createSelector([selectAccounts], (accounts) => accounts.query);

export const selectAccountsCreatedItem = createSelector([selectAccounts], (accounts) => accounts.create);

export const selectAccountsUpdatedItem = createSelector([selectAccounts], (accounts) => accounts.update);

export const selectAccountsReadItem = createSelector([selectAccounts], (accounts) => accounts.read);

export const selectAccountsDeletedItem = createSelector([selectAccounts], (accounts) => accounts.delete);

export const selectAccountsSearchedItems = createSelector([selectAccounts], (accounts) => accounts.search);

export const selectAccountsItemsCount = createSelector([selectAccounts], (accounts) => accounts.count);

export const selectAccountsItemsFilter = createSelector([selectAccounts], (accounts) => accounts.filter);